import { restClient } from '@/Core'

import type { DiskArchiveEntry, DiskArchiveListing } from '../Contracts/DiskArchive'

const num = (value: unknown): number => (typeof value === 'number' && Number.isFinite(value) ? value : 0)

const toEntry = (value: unknown): DiskArchiveEntry | null => {
    const raw = value as Record<string, unknown> | null

    if (raw === null || typeof raw !== 'object' || typeof raw['path'] !== 'string') return null

    return {
        path: raw['path'],
        dir: raw['dir'] === true,
        size: num(raw['size']),
        compressedSize: num(raw['compressedSize']),
        modifiedAt: typeof raw['modifiedAt'] === 'string' ? raw['modifiedAt'] : null,
        encrypted: raw['encrypted'] === true,
    }
}

/**
 * Вміст ZIP-архіву без розпакування: `GET /services/disk/files/{uuid}/archive`.
 * Не ZIP чи пошкоджений — 422 з поясненням (`diskErrorText`).
 */
export const LoadDiskArchiveTask = async (uuid: string): Promise<DiskArchiveListing> => {
    const response = (await restClient.get(
        `/services/disk/files/${encodeURIComponent(uuid)}/archive`,
        {},
        { forceRefresh: true }
    )) as unknown as Record<string, unknown> | null

    if (response === null || typeof response !== 'object' || !Array.isArray(response['entries'])) {
        throw new Error('Не вдалося прочитати вміст архіву')
    }

    const total = (response['total'] ?? {}) as Record<string, unknown>

    return {
        name: typeof response['name'] === 'string' ? response['name'] : '',
        version: num(response['version']),
        archiveSize: num(response['archiveSize']),
        entries: response['entries'].map(toEntry).filter((entry): entry is DiskArchiveEntry => entry !== null),
        total: {
            entries: num(total['entries']),
            files: num(total['files']),
            folders: num(total['folders']),
            size: num(total['size']),
            compressedSize: num(total['compressedSize']),
        },
        shown: num(response['shown']),
        hidden: num(response['hidden']),
        limit: num(response['limit']),
        encodings: Array.isArray(response['encodings'])
            ? response['encodings'].filter((item): item is string => typeof item === 'string')
            : [],
    }
}
